<div class="container-view">
  <div class="container-view__wrapper">

    <div class="container-add">
      <div class="container-add__video">
        <img class="container-add__video__img" src="/assets/translate_imgs/{{imgSrc}}" alt="Łatwo pobieraj i analizuj dane z tachografu">
      </div>

      <ng-container *ngIf="!emailIsSended">
          <h1 class="container-add__title">
          {{ 'handover.activate-functionality' | translate }}
          </h1>
          <span class="container-add__desc">
          {{ 'tachographInfoPermissionDenied' | translate }}
          </span>
          <button (click)="sendEmail()" class="container-add__submit">
          {{ 'handover.activate-functionality-im-interested' | translate }}
          </button>
      </ng-container>

      <div *ngIf="emailIsSended" class="container-add__email-sended">
          <img src="/assets/img/check.svg" class="check" alt="img">
          <span class="container-add__title">
              {{ 'handover.activate-functionality-success-title' | translate }}
          </span>
          <span class="container-add__desc">
              {{ 'handover.activate-functionality-success-desc' | translate }}
          </span>
      </div>
    </div>

  </div>
</div>
